<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex flex-row-reverse w-100">
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="main">
              <mat-icon
                class="mb-4"
                style="transform: scale(2.5)"
                svgIcon="success"
              ></mat-icon>
              <p class="message text-center mb-4 mt-3">
                Ordem de envio criada com sucesso!
              </p>
              <p
                [ngClass]="!isMobile ? 'text-padding' : ''"
                class="description mb-4"
              >
                Você pode prosseguir para realizar uma cotação e avançar no
                processo de envio, ou realizar a cotação em outro momento.
              </p>
              <button
                (click)="openQuotation()"
                *ngIf="isMobile"
                type="button"
                class="btn btn-block mt-4 w-100"
                [ngClass]="
                  companyId
                    ? 'btn-dark-primary-blue'
                    : 'btn-dark-primary-blue-pf'
                "
                type="button"
              >
                Prosseguir para a cotação
              </button>
              <button
                *ngIf="!isMobile"
                (click)="openQuotation()"
                type="button"
                class="btn btn-block mt-4 w-50"
                [ngClass]="
                  companyId
                    ? 'btn-dark-primary-blue'
                    : 'btn-dark-primary-blue-pf'
                "
                type="button"
              >
                Prosseguir para a cotação
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
